import React from 'react';
import ReactDOM from 'react-dom/client';
import { hydrateRoot, createRoot } from 'react-dom/client';
import App from './App';
import 'flag-icons/css/flag-icons.min.css';

// Verificar se está no browser (necessário para react-snap/SSR)
const isBrowser = typeof window !== 'undefined';

// Função para atualizar o atributo lang do HTML
const updateHtmlLang = () => {
  // Retornar default se não estiver no browser (react-snap/Puppeteer)
  if (!isBrowser) return 'pt-BR';
  
  const savedLanguage = localStorage.getItem('personalNutriLanguage');
  const browserLang = navigator.language || navigator.languages?.[0] || 'pt-BR';
  
  let currentLang = 'pt-BR'; // default
  
  if (savedLanguage) {
    currentLang = savedLanguage;
  } else {
    // Detectar idioma do navegador
    if (browserLang.startsWith('en')) currentLang = 'en-US';
    else if (browserLang.startsWith('es')) currentLang = 'es-ES';
    else if (browserLang.startsWith('pt')) currentLang = 'pt-BR';
  }
  
  // Atualizar atributo lang do HTML
  document.documentElement.lang = currentLang;
  
  return currentLang;
};

// Atualizar lang na inicialização (apenas no browser)
if (isBrowser) {
  updateHtmlLang();

  // Listener para mudanças no localStorage (quando o usuário muda o idioma)
  window.addEventListener('storage', (e) => {
    if (e.key === 'personalNutriLanguage') {
      updateHtmlLang();
    }
  });
}

// Suporte para react-snap: hidratar se já houver conteúdo pré-renderizado
const rootElement = document.getElementById('root');

if (rootElement.hasChildNodes()) {
  // Página pré-renderizada pelo react-snap - hidratar
  hydrateRoot(
    rootElement,
    <React.StrictMode>
      <App />
    </React.StrictMode>
  );
} else {
  // Renderização normal do cliente
  const root = createRoot(rootElement);
  root.render(
    <React.StrictMode>
      <App />
    </React.StrictMode>
  );
}
